<template>
  <div class="page-wrap">
    <a-card title="合同打开记录">
      <div class="toolbar">
        <a-input v-model.trim="keyword" class="filter-keyword" placeholder="用户、手机号或订单号" allow-clear @pressEnter="search" />
        <a-button type="primary" @click="search">查询</a-button>
      </div>
      <a-table row-key="id" :loading="loading" :columns="columns" :data-source="rows"
        :pagination="pagination" @change="changePage">
        <template slot="source" slot-scope="text">{{ { PC: 'PC端', MINI_PROGRAM: '小程序' }[text] || '未知' }}</template>
      </a-table>
    </a-card>
  </div>
</template>

<script>
import { getContractOpenRecordList } from '@/api'

export default {
  data() {
    return {
      keyword: '', loading: false, rows: [],
      pagination: { current: 1, pageSize: 20, total: 0, showSizeChanger: true },
      columns: [
        { title: '用户', dataIndex: 'userName' },
        { title: '手机号', dataIndex: 'userPhone', width: 130 },
        { title: '订单号', dataIndex: 'orderNo' },
        { title: '打开来源', dataIndex: 'source', width: 110, scopedSlots: { customRender: 'source' } },
        { title: '打开时间', dataIndex: 'createdAt', width: 180 }
      ]
    }
  },
  created() { this.loadData() },
  methods: {
    loadData() {
      this.loading = true
      getContractOpenRecordList({ keyword: this.keyword, page: this.pagination.current, pageSize: this.pagination.pageSize })
        .then(res => {
          const data = res.data || {}
          this.rows = data.records || []
          this.pagination.total = Number(data.total || 0)
        }).finally(() => { this.loading = false })
    },
    search() { this.pagination.current = 1; this.loadData() },
    changePage(page) { this.pagination.current = page.current; this.pagination.pageSize = page.pageSize; this.loadData() }
  }
}
</script>

<style scoped>
.page-wrap { padding: 20px; }
.toolbar { display: flex; align-items: center; gap: 12px; margin-bottom: 16px; }
.filter-keyword { flex: 0 0 280px; width: 280px; max-width: 100%; }
</style>
